export default {
  state: {
    city: '',
    map: {}
  },
  getters: {
    getMciudCity: state => state.city
  },
  mutations: {
    MCIUD_SET(state, [field, value]) {
      if (field.includes('.')) {
        const subField = field.split('.')
        state[subField[0]][subField[1]] = value
      } else {
        state[field] = value
      }
    }
  }
}
